// Module
var code = `<main class="flex flex-col flex-grow"> <div class="grid grid-rows-1 flex-grow h-full" *ngIf="dashboardId"> <app-bi-dashboard [workingMode]="'ViewerOnly'" [dashboardId]="dashboardId" [eventsDashboard]="eventsSubjectdashboard.asObservable()" [enableClearCache]="this.IsEnableCache" class="app-bi-dashboard"></app-bi-dashboard> </div> </main> `;
// Exports
export default code;